/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { DialogDefaultV2, InputV2, ArquivoContainerV2 } from '../../../components/v2';

const InvalidarDialog = ({ open, onClose, onConfirm, pedidoRow }) => {
  const [motivo, setMotivo] = useState('');
  const [motivoError, setMotivoError] = useState(false);
  const [arquivos, setArquivos] = useState([]);

  useEffect(() => {
    if (open) {
      setMotivo('');
      setMotivoError(false);
      setArquivos([]);
    }
  }, [open]);

  const handleConfirm = () => {
    if (!motivo || !motivo.trim()) {
      setMotivoError(true);
      return;
    }

    if (!pedidoRow?.id) {
      return;
    }

    onConfirm({
      status: 'INVALIDADO',
      motivoRestricao: motivo,
      arquivos,
    });
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onClose}
      handlerConfirm={handleConfirm}
      title="Negar Pedido de Voo"
      confirmMessage="Confirmar"
      cancelMessage="Cancelar"
      maxWidth="sm"
      fullWidth
      useFullScreen={false}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <InputV2
            label="Motivo"
            value={motivo}
            onChange={(e) => {
              setMotivo(e.target.value);
              if (e.target.value && e.target.value.trim()) setMotivoError(false);
            }}
            multiline
            rows={3}
            isRequired
            error={motivoError}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <ArquivoContainerV2
            arquivos={arquivos}
            disabled={false}
            onSave={setArquivos}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

InvalidarDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  pedidoRow: PropTypes.object,
};

InvalidarDialog.defaultProps = {
  pedidoRow: null,
};

export default InvalidarDialog;
